<template>
	<div class="buttons">
		<button class="btn--circle play" v-focus @click="play" v-tooltip.top="'Αναπαραγωγή'">
			<img src="../images/play.png" alt="Αναπαραγωγή" />
		</button>
		<ButtonFavorites v-if="isLoggedIn" :item="props.item" :type="props.type" />
		<button
			v-tooltip.top="muted ? 'Ενεργοποίηση ήχου' : 'Σίγαση ήχου'"
			class="btn--circle volume"
			v-focus
			:class="{ muted: muted === true }"
			@click="triggerVolume"
		>
			<IconVolume />
		</button>
		<button v-tooltip.top="'Προβολή πληροφοριών'" class="btn--circle inner-page" v-focus @click="gotoInnerPage">
			<IconArrowBottom />
		</button>
	</div>
</template>

<script lang="ts" setup>
	import { ref, computed, ComputedRef } from "vue"
	import { useUserStore } from "../stores/user"
	import { useLogin } from "../composables/useLogin"
	import router from "../router/router"
	import { useMovieStore } from "../stores/movies"
	import IconVolume from "../icons/IconVolume.vue"
	import IconArrowBottom from "../icons/IconArrowBottom.vue"
	import ButtonFavorites from "./actions/ButtonFavorites.vue"
	import { useTeaserStore } from "../stores/teaser"

	const userStore = useUserStore()
	const props = defineProps<{
		item: any
		type: string
		player: any
		episode_nid: number
	}>()
	const isLoggedIn: ComputedRef<boolean> = computed(
		(): boolean => userStore.state.isLoggedIn && userStore.state.selected_profile
	)
	const muted = computed(() => {
		return userStore.state.mute || false
	})
	const addedToList = ref(false)
	const isAddedToFavorites = computed(() => {
		if (props.item.markit__add_to_my_list === 0) {
			addedToList.value = false
		} else {
			addedToList.value = true
		}
		return addedToList.value
	})

	/**
	 * Local play function, that triggers the store play function.
	 * @param type
	 * @param item
	 * @param episode_nid
	 * @param router
	 */
	const play = () => {
		useTeaserStore().play(props.type, props.item, props.episode_nid, router)
	}
	const { login } = useLogin()
	const gotoInnerPage = () => {
		if (props.type?.includes("movie")) {
			router.push({ name: "InnerMovie", params: { id: props.item.drupal_internal__nid } })
		} else if (props.type?.includes("series")) {
			router.push({ name: "InnerSeries", params: { id: props.item.drupal_internal__nid } })
		}
	}

	const triggerVolume = () => {
		// const player = player.value?.player;

		const player = window.kwikMotion(`kwik-player-${props.player}`)
		// const player = props.player?.player
		if (userStore.state.mute === true) {
			player.muted(false)
			userStore.state.mute = false
		} else {
			player.muted(true)
			userStore.state.mute = true
		}
	}
</script>

<style lang="scss" scoped>
	.buttons {
		display: flex;
		gap: 15px;
		// margin-top: 25px;
		align-items: center;
	}
	.inner-page,
	.volume,
	.add-to-list {
		width: 45px;
		height: 45px;
		svg {
			width: 25px;
			height: 25px;
		}
		.active {
			display: none;
		}
		.default {
			display: block;
		}
		&.active {
			.active {
				display: block;
			}
			.default {
				display: none;
			}
		}
	}

	.play {
		width: 45px;
		height: 45px;
		background: var(--white);
		img {
			width: 25px;
			height: 25px;
		}
	}
	.inner-page {
		margin-left: auto;
	}
	.volume {
		&.muted {
			position: relative;
			opacity: 0.5;
			&::after {
				content: "";
				position: absolute;
				display: flex;
				left: 5px;
				right: 5px;
				height: 3px;
				background: var(--white);
				transform: rotate(45deg);
			}
			&:hover {
				opacity: 1;
			}
		}
		&:hover {
			cursor: pointer;
		}
	}
</style>
